import { render, staticRenderFns } from "./AccordionSupplier.vue?vue&type=template&id=6d428a36&scoped=true&"
import script from "./AccordionSupplier.vue?vue&type=script&lang=js&"
export * from "./AccordionSupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d428a36",
  null
  
)

export default component.exports